export default __webpack_public_path__ + "static/media/bg.7d139629.png";